import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';

import ListItemText from '@material-ui/core/ListItemText';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import AddIcon from '@material-ui/icons/Add';
import FolderIcon from '@material-ui/icons/Folder';
import HelpIcon from '@material-ui/icons/HelpOutline';
import FeedbackIcon from '@material-ui/icons/Feedback';
import PersonIcon from '@material-ui/icons/Person';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

import { URL } from '../../../utils/constants';
import { CustomMenuItem, CustomListItemIcon } from './styles';
import { useTranslation } from 'react-i18next';

const UserMenu = ({
	handleNewDesign,
	handleMyDesigns,
	handleAbout,
	handleFeedback,
	handleLogin,
	isUserLoggedIn,
	isInputTabActive
}) => {
	const { t } = useTranslation();

	return (
		<PopupState variant="popover" popupId="navbar-menu">
			{popupState => {
				const closeMenu = func => () => popupState.close(func());

				return (
					<Fragment>
						<IconButton color="inherit" {...bindTrigger(popupState)}>
							<MoreVertIcon />
						</IconButton>

						<Menu
							elevation={2}
							keepMounted
							MenuListProps={{
								style: {
									padding: 0
								}
							}}
							{...bindMenu(popupState)}>
							{!isInputTabActive() && (
								<CustomMenuItem onClick={closeMenu(handleNewDesign)}>
									<CustomListItemIcon>
										<AddIcon fontSize="small" />
									</CustomListItemIcon>
									<ListItemText primary={t('components.navbar.userMenu.texts.newDesign')} />
								</CustomMenuItem>
							)}

							<CustomMenuItem disabled={!isUserLoggedIn} onClick={closeMenu(handleMyDesigns)}>
								<CustomListItemIcon>
									<FolderIcon fontSize="small" />
								</CustomListItemIcon>
								<ListItemText primary={t('components.navbar.userMenu.texts.myDesigns')} />
							</CustomMenuItem>

							<CustomMenuItem
								disabled={!isUserLoggedIn}
								onClick={closeMenu(() => window.open(URL.ONSEMI_MY_ON_PROFILE, '_blank'))}>
								<CustomListItemIcon>
									<PersonIcon fontSize="small" />
								</CustomListItemIcon>
								<ListItemText primary={t('components.navbar.userMenu.texts.onProfile')} />
							</CustomMenuItem>

							<CustomMenuItem onClick={closeMenu(handleAbout)}>
								<CustomListItemIcon>
									<HelpIcon fontSize="small" />
								</CustomListItemIcon>
								<ListItemText primary={t('components.navbar.userMenu.texts.about')} />
							</CustomMenuItem>

							<CustomMenuItem onClick={closeMenu(handleFeedback)}>
								<CustomListItemIcon>
									<FeedbackIcon fontSize="small" />
								</CustomListItemIcon>
								<ListItemText primary={t('components.navbar.userMenu.texts.feedback')} />
							</CustomMenuItem>

							<CustomMenuItem onClick={closeMenu(() => handleLogin(!isUserLoggedIn))}>
								<CustomListItemIcon>
									{isUserLoggedIn ? <PowerSettingsNewIcon fontSize="small" /> : <AccountCircleIcon fontSize="small" />}
								</CustomListItemIcon>
								<ListItemText
									primary={
										isUserLoggedIn
											? t('components.navbar.userMenu.texts.logout')
											: t('components.navbar.userMenu.texts.login')
									}
								/>
							</CustomMenuItem>
						</Menu>
					</Fragment>
				);
			}}
		</PopupState>
	);
};

UserMenu.propTypes = {
	handleNewDesign: PropTypes.func.isRequired,
	handleMyDesigns: PropTypes.func.isRequired,
	handleAbout: PropTypes.func.isRequired,
	handleFeedback: PropTypes.func.isRequired,
	handleLogin: PropTypes.func.isRequired,
	isUserLoggedIn: PropTypes.bool.isRequired,
	isInputTabActive: PropTypes.func.isRequired
};

export default UserMenu;
